import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import BackStockOrderList from '../entities/back-stockorder'
import createdata from '@/store/entities/create-stockorder'

interface BackStockOrderState extends ListState<BackStockOrderList> {
    orderInfo: createdata,
}

class BackStockOrderMutations extends ListMutations<BackStockOrderList>{

}
class BackStockOrder extends ListModule<BackStockOrderState, any, BackStockOrderList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<BackStockOrderList>(),
        loading: false,
        updateOrdeData: null,
        ids: [],
        id:0,
        BaseSkuNums: 0,
        findList: null,
    }
    actions = {
        async getAll(context: ActionContext<BackStockOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/BackStockOrder/GetStockOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<BackStockOrderList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        //async getOrder(context: ActionContext<BackStockOrderState, any>, payload: any) {
        //    let reponse = await Ajax.get('/api/services/app/BackStockOrder/GetOrderInfo', { params: payload.data });
        //    context.state.orderInfo = (reponse.data.result as createdata);
        //},

        
        //打包
        async stockOrderBale(context: ActionContext<BackStockOrderState, any>, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStockOrder/StockOrderBale', payload.data);
        },
        //撤销订单
        async cancelUrgentOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStockOrder/cancelUrgentOrder?id=' + payload.data.stockOrderId);
        },
        //撤销订单
        async cancleStockOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStockOrder/cancleStockOrder?stockOrderId=' + payload.data.stockOrderId);
        },
        //取消打包
        async cancleBale(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStockOrder/CancleBale' ,payload.data);
        },
        //标记正常异常
        async procesOrderStatu(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStockOrder/ProcesOrderStatu', payload.data);
        },
        //称重打包
        async goodsInfoAdd(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStockOrder/GoodsWeigh', payload.data);
            return rep.data.result;
        },
        async editShipment(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStockOrder/EditInterNationalShipment?id=' + payload.data.id + '&mainLandPackageId=' + payload.data.mainLandPackageId);
        },
        async updatePackageStatus(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackStockOrder/ProcessOrderPackageStatus', payload.data);
        },
        async getFindOrder(context: ActionContext<BackStockOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/BackStockOrder/GetFindStockOrderList', { params: payload.data });
            context.state.loading = false;
            return reponse.data.result;

        },
        //async commodityWeigh(state: any, payload: any) {
        //    let rep = await Ajax.post('/api/services/app/BackStockOrder/CommodityWeigh?tradeNo=' + payload.data.tradeNo + '&resultWeight=' + payload.data.resultWeight);
        //},
        async impotExcel(state: any, payload: any) {
            Ajax.get('/api/File/GetExpressExportMainlandStockOrderInfo', { params: payload.data, responseType: "blob" }).then(res => {
                const content = res.data;
                const blob = new Blob([content]);
                const fileName = '囤货订单信息.xlsx'
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                }
            });
        },
    };
    mutations = {
        setCurrentPage(state: BackStockOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackStockOrderState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const backstockorders = new BackStockOrder();
export default backstockorders;